import styled from 'styled-components'
import breakpoints from 'src/styles/breakpoints'

export const UL = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    svg {
      fill: ${(props) => props.theme.colors.primary};
    }
    display: inline;
    margin-right: 18px;

    @media (min-width: ${breakpoints.md}) {
      margin-right: 7px;
    }
    @media (min-width: ${breakpoints.lg}) {
      margin-right: 18px;
    }
  }
`
